module.exports = __webpack_public_path__ + "assets/img/6_523.74e0078d.jpg";